"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var repositoryAdmin;
        (function (repositoryAdmin) {
            var create;
            (function (create) {
                class InitArgs {
                    constructor() {
                        this.storeItemId = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    if (!$('#Item_Name').val()) {
                        $('select#Item_ItemType').val(appn.emptyString);
                        appn.select.init({
                            selector: 'select#Item_ItemType'
                        });
                    }
                    else {
                        setInstanceIds($('select#Item_ItemType'));
                        $('select#Item_InstanceId').val(_initArgs.storeItemId);
                        $('select#Item_InstanceId').showElement();
                    }
                }
                create.init = init;
                function addEvents() {
                    $(document).on('change', 'select#Item_ItemType', function () {
                        setInstanceIds($(this));
                        appn.select.init({
                            selector: 'select#iconsToDisplay',
                            isIconSelect: true
                        });
                    });
                    $(document).on('change', 'select#Item_InstanceId', function () {
                        $('#Item_Name').val($('#Item_InstanceId option:selected').text());
                    });
                }
                function setInstanceIds(itemType) {
                    $('#formsnote').hideElement();
                    $('#foldersnote').hideElement();
                    const $type = $('select#Item_InstanceId');
                    $type.empty();
                    $type.append('<option value="">' + appn.strings.choose + '</option>');
                    $type.append($('#dropDownFor' + itemType.val()).children().clone());
                    switch (itemType.val()) {
                        case 'Screen': {
                            $('#formsnote').showElement();
                            $type.showElement();
                            break;
                        }
                        case 'Doc':
                        case 'DataSource':
                        case 'TaskTemplate': {
                            $type.showElement();
                            break;
                        }
                        case 'Folder': {
                            $('#foldersnote').showElement();
                            $type.showElement();
                            break;
                        }
                        default: {
                            $type.hideElement();
                            break;
                        }
                    }
                    appn.select.init({
                        selector: 'select#Item_InstanceId'
                    });
                }
            })(create = repositoryAdmin.create || (repositoryAdmin.create = {}));
        })(repositoryAdmin = views.repositoryAdmin || (views.repositoryAdmin = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
